export default {
  container: {
    p: 3,
    maxWidth: 768
  }
};
